define( '../src/sublayouts/_helpers/toggle-menu/toggle-menu',[ 'jquery', 'breakpoint', 'lib/utils' ], function ( $, breakpoint, utils ) {

	'use strict';

	/**
	 * Toggle menu - currently only triggers for mobile view only.
	 */

	var ToggleMenu = function ( $component ) {

		this.$component = $component;

		return this;
	};

	ToggleMenu.prototype.init = function () {

		this.$trigger = this.$component.find( '[data-toggle-trigger="true"]' );
		this.$content = this.$component.find( '[data-toggle-content="true"]' );
		this.autoOpen = this.$component.data( 'toggle-auto-open' );

		this.activeClass = 'toggle-menu--active';
		this.activeToggleClass = 'toggle-menu__trigger--active';
		this.triggerBreakpoint = this.$component.data( 'toggle-breakpoint' ) === undefined ? 's' : this.$component.data( 'toggle-breakpoint' );

		this.respond();
		this.active = false;

		if ( this.triggerBreakpoint === 'l' ) {

			this.display();
			if ( this.autoOpen ) {
				this.toggle( this.$trigger.eq( 0 ) );
			}

		} else {

			$( breakpoint ).on( 'change', $.proxy( this.respond, this ) );
			$( window ).on( 'orientationchange', $.proxy( this.orientationchange, this ) );
		}
	};

	ToggleMenu.prototype.respond = function () {

		var self = this;

		if ( ( this.triggerBreakpoint === 's' && utils.breakpoint() === 's' ) || this.triggerBreakpoint === 'm' && ( utils.breakpoint() === 's' || utils.breakpoint() === 'm' ) ) {

			self.display();

		} else {

			this.reset();
		}

	};

	ToggleMenu.prototype.display = function () {

		var self = this;
		if ( !this.active ) {

			this.$component.addClass( this.activeClass );
			this.$content.hide();

			this.$trigger.on( 'click', function () {
				self.toggle( $( this ) );
			} );

			// test for empty toggles
			$.each( this.$trigger, function () {

				if ( $( this ).next().length === 0 ) {

					$( this ).addClass( 'toggle-menu__trigger--empty' ).attr( 'tabindex', '-1' );
					$( this ).off( 'click' );
				}
			} );

			this.active = true;
		}
	};

	ToggleMenu.prototype.toggle = function ( $toggle ) {

		var $currentContent = $toggle.next();
		this.$content.not( $currentContent ).hide();
		this.$trigger.not( $toggle ).removeClass( this.activeToggleClass );

		$toggle.toggleClass( this.activeToggleClass );
		$currentContent.toggle();

	};

	ToggleMenu.prototype.orientationchange = function () {

		this.reset();
		this.respond();
	};

	ToggleMenu.prototype.reset = function () {
		this.$component.removeClass( this.activeClass );
		this.$trigger.off();
		this.$trigger.removeClass( this.activeToggleClass );
		this.$content.removeAttr( 'style' );
		this.active = false;
	};

	return ToggleMenu;

} );

